import { Routes, Route, Navigate } from "react-router-dom";
import DragBracket from "./drag-race-bracket.jsx";
import AdminPanel from "./drag-bracket-admin.jsx";

export default function App() {
  return (
    <Routes>
      {/* Main player-facing bracket app */}
      <Route path="/" element={<DragBracket />} />

      {/* Admin panel */}
      <Route path="/admin" element={<AdminPanel />} />

      {/*
        NOTE: /bracket is intentionally NOT defined here.
        It's served as a static HTML file from public/bracket/index.html
        and bypasses React Router entirely.
      */}

      {/* Anything else → home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
